import { render, staticRenderFns } from "./charmOnePageDetail.vue?vue&type=template&id=2bfd0e88"
import script from "./charmOnePageDetail.vue?vue&type=script&lang=js"
export * from "./charmOnePageDetail.vue?vue&type=script&lang=js"
import style0 from "./charmOnePageDetail.vue?vue&type=style&index=0&id=2bfd0e88&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bfd0e88')) {
      api.createRecord('2bfd0e88', component.options)
    } else {
      api.reload('2bfd0e88', component.options)
    }
    module.hot.accept("./charmOnePageDetail.vue?vue&type=template&id=2bfd0e88", function () {
      api.rerender('2bfd0e88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/charm/charmOnePageDetail.vue"
export default component.exports